"use strict";
/**
 * editCompileWebsiteExternalSystemModule Module
 *
 * Description
 */
angular.module('appExternalSystemModule', ['externalSystemRouterModule'])
    .controller('appExternalSystemController', ['$scope', '$sce', '$stateParams', function($scope, $sce, $stateParams) {
        $scope.ifrSrc = $sce.trustAsResourceUrl(unescape($stateParams.externalsystemurl));
        // $("body").css("overflow", "hidden");
        /*iframe设置高度*/
        $("#iframe_externalSystem_to_editingCenter").load(function() {
            var iframe_externalSystem_to_editingCenter_height = $(window).height() - 110;
            $(this).height(iframe_externalSystem_to_editingCenter_height);
        });
        $scope.$on("$destroy", function() {
            $("body").css("overflow", "initial");
        });
    }]);
